// Copyright (c) 2021-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { JsonObject } from "../io/hyperify/core/Json";

/**
 * This service does not enable cors mode.
 */
export class SimpleHttpService {

    public static getJson (url: string) : Promise<JsonObject> {
        return fetch(url).then(response => response.json());
    }

}
